<script setup lang="ts">
import GroupEntityItemThumbnailComponent from '../../group/GroupEntityItemThumbnailComponent.vue'
import {IParticularColor} from '@toolify/server/src/services/ColorService/types/IParticularColor'
import {useParticularColors} from '@toolify/client/src/modules/color/composables/useParticularColors'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'

interface Props {
  payload: {
    color: IParticularColor
    iconNameType?: IconNameType
  }
}
const props = withDefaults(defineProps<Props>(), {
  payload: () => ({
    color: null,
    iconNameType: null,
  }),
})

const {getColorByParticularColor} = useParticularColors()
</script>

<template>
  <GroupEntityItemThumbnailComponent :color="getColorByParticularColor(props.payload.color)" :iconNameType="props.payload.iconNameType"/>
</template>
